export const activateEventBus = () => {
	// Subscribe to wallet events and update the SRP listings accordingly.
	if (!window.caiEventBus) {
		// Save a network request by embedding the pubsub library here.
		// Source: https://unpkg.com/mitt/dist/mitt.umd.js
		/* eslint-disable */
		!function(e,n){"object"==typeof exports&&"undefined"!=typeof module?module.exports=n():"function"==typeof define&&define.amd?define(n):(e=e||self).mitt=n()}(this,function(){return function(e){return{all:e=e||new Map,on:function(n,t){var f=e.get(n);f?f.push(t):e.set(n,[t])},off:function(n,t){var f=e.get(n);f&&(t?f.splice(f.indexOf(t)>>>0,1):e.set(n,[]))},emit:function(n,t){var f=e.get(n);f&&f.slice().map(function(e){e(t)}),(f=e.get("*"))&&f.slice().map(function(e){e(n,t)})}}}});
		/* eslint-enable */
		window.caiEventBus = window.mitt();

		// TODO: remove this line once cms-web updates are complete
		// FOR BACKWARDS COMPATIBILITY UNTIL window.CAIEventBus IS SWAPPED OUT HERE:
		// https://ghe.coxautoinc.com/DDC-WebPlatform/cms-web/blob/a484011a86eb7e5b49363564b89dbafc62813fec/htdocs/v9/viewmodel/components/digital_retailing/cox/component.js#L168-L170
		window.CAIEventBus = window.caiEventBus;
	}
}
